import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { managersActions } from 'features/managers';

const useManagers = () => {
  const dispatch = useDispatch();
  const getManagers = useCallback(({ offset, query }) => dispatch(managersActions.getManagers({ offset, query })), [dispatch]);
  const getManager = useCallback(id => dispatch(managersActions.getManager(id)), [dispatch]);
  const createManager = useCallback(({ manager, invitation_token }) => dispatch(managersActions.createManager({ manager, invitation_token })), [dispatch]);
  const updateManager = useCallback(manager => dispatch(managersActions.updateManager(manager)), [dispatch]);
  const deleteManager = useCallback(id => dispatch(managersActions.deleteManager(id)), [dispatch]);
  const clearLocalManagers = useCallback(() => dispatch(managersActions.clearLocalManagers()), [dispatch]);
  const clearLocalActiveManager = useCallback(() => dispatch(managersActions.clearLocalActiveManager()), [dispatch]);

  return {
    getManagers,
    getManager,
    createManager,
    updateManager,
    deleteManager,
    clearLocalManagers,
    clearLocalActiveManager
  };
};

export default useManagers;